import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { featuredProducts } from "@/mocks/home";

export default function Collection() {
  const root = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!root.current) return;
    const ctx = gsap.context(() => {
      gsap.from(".col-card", {
        y: 60,
        opacity: 0,
        duration: 1,
        stagger: 0.12,
        ease: "power3.out",
        scrollTrigger: { trigger: root.current, start: "top 70%" },
      });
    }, root);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={root} className="bg-bone pt-4 pb-16 md:pb-20 px-6 md:px-10">
      <div className="flex flex-col md:flex-row items-start md:items-end justify-between mb-8 md:mb-10 gap-6">
        <div>
          <p className="text-[11px] font-mono uppercase tracking-[0.22em] text-ink/50 mb-4">
            ✦ Spring–Summer №24
          </p>
          <h3 className="font-display text-4xl md:text-6xl text-ink tracking-tightest font-light leading-[0.95]">
            The Atelier <span className="font-display text-rust">Collection</span>
          </h3>
        </div>
        <div className="flex items-center gap-3">
          <a
            href="/shop"
            className="text-ink text-sm uppercase tracking-wide border-b border-ink/30 pb-1 hover:border-ink cursor-pointer whitespace-nowrap"
          >
            View all 42 pieces →
          </a>
        </div>
      </div>

      <div
        className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6"
        data-product-shop
      >
        {featuredProducts.slice(0, 4).map((p, i) => (
          <article
            key={p.id}
            className={`col-card group relative ${
              i === 1 ? "lg:translate-y-12" : ""
            } ${i === 3 ? "lg:translate-y-12" : ""}`}
          >
            <div className="relative aspect-[3/4] rounded-2xl overflow-hidden bg-sand">
              <img
                src={p.image}
                alt={p.name}
                className="w-full h-full object-cover object-top transition-transform duration-[1200ms] ease-out group-hover:scale-105"
              />
              <button className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center rounded-full bg-bone/90 backdrop-blur text-ink hover:bg-bone cursor-pointer opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-heart-line text-sm"></i>
              </button>
              <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between opacity-0 group-hover:opacity-100 transition-all duration-500 translate-y-2 group-hover:translate-y-0">
                <span className="px-3 py-1.5 rounded-full bg-bone/90 backdrop-blur text-[10px] font-mono uppercase tracking-[0.18em] text-ink">
                  Quick view
                </span>
                <span className="w-9 h-9 flex items-center justify-center rounded-full bg-ink text-bone cursor-pointer">
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </span>
              </div>
            </div>
            <div className="mt-4 flex items-start justify-between gap-3">
              <div>
                <h4 className="font-display text-lg text-ink tracking-tightest font-medium">
                  <a href="/shop" className="hover:underline cursor-pointer">{p.name}</a>
                </h4>
                <p className="text-xs text-ink/60 mt-1">{p.material}</p>
              </div>
              <p className="font-display text-xl text-ink tracking-tightest font-light whitespace-nowrap">
                €{p.price}
              </p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}